export const adminlinks = [
  { id: 1, text: 'stats', path: '/' },
  { id: 2, text: 'allLessons', path: 'allLessons' },
  { id: 3, text: 'add lesson', path: 'addlesson' },
  { id: 4, text: 'profile', path: 'profile' },
];
